export default __webpack_public_path__ + "static/media/logo-sm.a84c24f5.png";